/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IBusinessShoppingCenterSchema } from '../../../../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';
import { offerSelector } from '../../../../../selectors';
import { businessShoppingCenterSelector } from '../../../../../selectors/offerData/offer/businessShoppingCenterSelector';
import { IFeatureItem } from '../../../../../types/offerData';
import { getOfferType, isCommercial } from '../../../../../utils/offer_type';
import { createFeatureList } from './createFeatureList';
import { showFullInfo } from './showFullInfo';

const FEATURES_MAX_COUNT = 10;

export const useFeaturesCommercialProps = () => {
  const offer = useSelector(offerSelector);
  const businessShoppingCenter = useSelector(businessShoppingCenterSelector) as IBusinessShoppingCenterSchema;

  const offerType = getOfferType(offer);
  const isCommercialOffer = isCommercial(offerType);

  if (!isCommercialOffer && !businessShoppingCenter) {
    return null;
  }

  const featuresList = createFeatureList(offer, businessShoppingCenter);

  if (!featuresList.length) {
    return null;
  }

  const [isOpen, setOpen] = React.useState(showFullInfo(featuresList));

  const handleFeaturesOpen = React.useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  return React.useMemo(
    () =>
      isOpen
        ? {
            title: 'Инфраструктура',
            featuresList,
            onOpen: handleFeaturesOpen,
            showOpenButton: false,
          }
        : {
            title: 'Инфраструктура',
            featuresList: featuresList.slice(0, FEATURES_MAX_COUNT) as IFeatureItem[],
            onOpen: handleFeaturesOpen,
            showOpenButton: true,
          },
    [featuresList, isOpen, handleFeaturesOpen],
  );
};
